import { Text } from '../../../../typography/text/Text';
import PropTypes from 'prop-types';
import React from 'react';

const ProductName = ({
  name = '',
  className = '',
  size = 'sm',
  onClick = () => {},
}) => {
  return (
    <Text
      as="span"
      size={size}
      className={className}
      onClick={onClick}
      inlineStyles={{
        whiteSpace: 'normal'
      }}
    >
      {name}
    </Text>
  );
};

export default ProductName;

ProductName.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
};
